import React, { useCallback, useMemo } from 'react';
import SessionCalibration from './SessionCalibration';
import SessionVideosync from './SessionVideosync';
import SessionVideoOrder from './SessionVideoOrder';
import SessionLineups from './Lineup/SessionLineups';
import SessionTeamSpecification from './SessionTeamSpecification';
import SessionFlowBase, { TStep } from './SessionFlowBase';
import { RouteComponentProps } from 'react-router';
import { TSession } from './Sessions';
import SessionPeriods from './SessionPeriods';
import SessionEvents from './SessionEvents';
import useHasPrivilege from '../Util/useHasPrivilege';
import { Privilege } from '../../api';
import SessionSettings from './SessionSettings';

type TParams = {
  session: string;
  step?: string;
};

interface Props extends RouteComponentProps<TParams> {}

export const steps = (isAdmin: boolean): Array<TStep> => [
  {
    step: 'order',
    title: 'Video order',
    component: SessionVideoOrder,
    filter: (session: TSession) => (session.videos?.length || 0) > 1,
  },
  { step: 'calibration', title: 'Calibration', component: SessionCalibration },
  {
    step: 'sync',
    title: 'Video synchronization',
    component: SessionVideosync,
    filter: (session: TSession) => (session.videos?.length || 0) > 1,
  },
  { step: 'periods', title: 'Periods', component: SessionPeriods, requiredSteps: ['sync'], },
  { step: 'lineups', title: 'Line-ups', component: SessionLineups },
  { step: 'events', title: 'Events', component: SessionEvents, requiredSteps: ['sync'], },
  { step: 'teamspec', title: 'Team Specification', component: SessionTeamSpecification, requiredSteps: ['sync', 'calibration'], },
  { step: 'settings', title: 'Settings', component: SessionSettings, filter: () => isAdmin },
];

const SessionPrepareFlow = (props: Props) => {
  const isAdmin = useHasPrivilege(Privilege.Admin);
  const onClose = useCallback(() => {
    props.history.push('/sessions');
  }, [props]);

  const theSteps = useMemo(() => {
    return steps(isAdmin);
  }, [isAdmin]);

  return (
    <SessionFlowBase
      sessionid={props.match.params.session}
      step={props.match.params.step}
      steps={theSteps}
      close={onClose}
      canStartSession
      flow="prepare"
    />
  );
};

export default SessionPrepareFlow;
